function extract(key, from) {
    if (from &&
        typeof from === 'object' &&
        Object.prototype.hasOwnProperty.call(from, key)) {
        return from[key];
    }
    return undefined;
}
function extractParts(parts, from) {
    if (parts.length === 0)
        return from;
    const [nextPath, ...rest] = parts;
    const next = extract(nextPath, from);
    if (parts.length === 1 || next === undefined)
        return next;
    return extractParts(rest, next);
}
function extractPath(path, from) {
    return extractParts(path.split('.'), from);
}
function accountClaims(claimList, key) {
    const type = key.substring('gitboard-accounts-'.length);
    return claimList.map((it) => ({ ...it, type }));
}
export function accountClaimsFrom(claims = {}) {
    const keys = Object.keys(claims).filter((it) => it.startsWith('gitboard-accounts'));
    const access = keys.flatMap((key) => accountClaims(JSON.parse(claims[key]), key));
    const userAccount = access.find((it) => it.type === 'user');
    if (!userAccount)
        return undefined;
    return {
        userAccount,
        otherAccounts: access.filter((it) => it.type !== 'user'),
    };
}
export function planClaimsFrom(claims = {}) {
    const planString = claims['gitboard-plan'];
    if (!planString) {
        return undefined;
    }
    return JSON.parse(planString);
}
export function claimsFrom(event) {
    const claims = extractPath('requestContext.authorizer.claims', event);
    if (claims) {
        const username = claims.email ?? 'unknown';
        console.log(`Discovered user ${username} has cognito groups ${claims['cognito:groups'] ?? []}`);
        const accountAccess = accountClaimsFrom(claims);
        if (!accountAccess)
            return undefined;
        const plan = planClaimsFrom(claims);
        return {
            username,
            plan,
            accounts: accountAccess,
            admin: (claims['cognito:groups'] ?? []).includes('gitboard-admin-users'),
        };
    }
    console.warn('No claims could be found');
    return undefined;
}
export function authorized(handler) {
    return (async (event, ...rest) => {
        const claims = claimsFrom(event);
        if (!claims)
            return { statusCode: 403, body: 'Access Denied' };
        return handler(claims)(event, ...rest);
    });
}
export function accessForAccount(claims, id) {
    if (claims.admin)
        return { accountId: id, access: 'admin' };
    const access = [claims.accounts.userAccount, ...claims.accounts.otherAccounts].find((it) => it.id === id)?.access ?? 'none';
    return { accountId: id, access };
}
export function accessFor(claims, id, type) {
    const accountId = `${type}:${id}`;
    if (claims.admin)
        return { accountId, access: 'admin' };
    const access = claims.accounts.otherAccounts.find((it) => it.type === type && it.id === id)
        ?.access ?? 'none';
    return { accountId, access };
}
